import { render, staticRenderFns } from "./SendToCustomerModal.vue?vue&type=template&id=02d450cc&scoped=true&"
import script from "./SendToCustomerModal.vue?vue&type=script&lang=js&"
export * from "./SendToCustomerModal.vue?vue&type=script&lang=js&"
import style0 from "./SendToCustomerModal.vue?vue&type=style&index=0&id=02d450cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d450cc",
  null
  
)

export default component.exports